import { Box } from "@mui/material";
import React from "react";
import DemographicBreakdown from "../../components/project/overview/DemographicBreakdown.tsx";
import Description from "../../components/project/overview/Description.tsx";
import EmptyPatient from "../../components/project/overview/EmptyPatient.tsx";
import GeographicBreakdown from "../../components/project/overview/GeographicBreakdown.tsx";
import JumpTo from "../../components/project/overview/JumpTo.tsx";
import PatientEncounters from "../../components/project/overview/PatientEncounters.tsx";
import ProjectMetricCards from "../../components/project/projectmetriccards/ProjectMetricCards.tsx";
import { projectTypes } from "../../utils/main.ts";

export default function Overview({
  project,
  projectSummary,
}: {
  project: ProjectContextType;
  projectSummary: Partial<DeviceSearchResponse>;
}) {
  return (
    <Box className="description-body" sx={{ bgcolor: "grey.50" }}>
      <div className={"description-left-panel"}>
        <Description project={project} />
        <JumpTo type={project.type} />
      </div>
      <div className="description-scroll">
        {projectSummary && projectSummary.totalPatients === 0 ? (
          <EmptyPatient />
        ) : (
          <>
            <div className="stats-container">
              <ProjectMetricCards data={projectSummary} />
            </div>
            {project.type === projectTypes.device && (
              <PatientEncounters data={projectSummary} />
            )}
            <DemographicBreakdown data={projectSummary} />
            <GeographicBreakdown states={projectSummary.states ?? []} />
          </>
        )}
      </div>
    </Box>
  );
}
